export default (theme) => ({
  tabBar: {
    position: 'fixed',
    background: theme.palette.background.white,
    zIndex: 1000,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'none',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 'auto',
    minHeight: 70,
    width: '100%',
    padding: 16,
    boxSizing: 'border-box',
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    [theme.breakpoints.down('md')]: {
      display: 'flex',
    },
  },
  overlay: {
    backgroundColor: 'black',
    opacity: 0.5,
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100%',
    zIndex: 1,
  },
});
